import { Pipe, PipeTransform } from '@angular/core';
/**
  * FullNamePipe
  *
  * A pipe to return fullname of a user.
  */
@Pipe({ name: 'fullName' })
export class FullNamePipe implements PipeTransform {
  /**
  * Accepts a user Object and returns fullname.
  *
  * @param {any} user A user Object.
  * @return {string} Returns fullname.
  */
  transform(user: any): string {
    return user?.first_name || user?.last_name ? `${user?.first_name} ${user?.last_name}` : user?.email.split('@')[0] || '--';
  }
}
